"use strict";
import Swiper from "swiper";
import { Navigation } from "swiper/modules";

export default function () {
    document.addEventListener("DOMContentLoaded", () => {
        const initSlider = document.querySelector(".o-pacote__slider");
        if (!initSlider) return;
        const swiper = new Swiper(".o-pacote__slider", {
            modules: [Navigation],
            slidesPerView: 2,
            spaceBetween: 30,
            loop: false,

            navigation: {
                nextEl: ".o-pacote__arrow--next",
                prevEl: ".o-pacote__arrow--prev",
            },

            breakpoints: {
                0: { slidesPerView: 1 },
                1024: { slidesPerView: 2 },
            },
        });

        // Progress bar update
        const progressBar = document.querySelector(".o-pacote__progress-bar");

        swiper.on("slideChange", () => {
            const progress =
                ((swiper.activeIndex + 1) / swiper.slides.length) * 100;
            progressBar.style.width = progress + "%";
        });

        // Set initial progress
        const initialProgress = (1 / swiper.slides.length) * 100;
        progressBar.style.width = initialProgress + "%";
    });
}
